import React from "react";

const About = () => {
  return (
    <section className="section">
      <div className="container narrow">
        <h1 className="section-title">About Wellness Minds</h1>
        <p className="section-intro">
          Wellness Minds was born from a simple idea: mental wellness support should feel
          as normal as checking the weather or sending a message to a friend. The goal is
          to offer compassionate, digital-first support that helps people slow down, notice
          what they&apos;re feeling and respond with more kindness to themselves.
        </p>

        <h2 className="about-heading">Our focus</h2>
        <ul className="about-list">
          <li>
            <strong>Everyday mental wellness.</strong> We focus on the space between
            &quot;I&apos;m fine&quot; and crisis — the days when you&apos;re tired, stressed
            or emotionally overloaded but still trying to keep going.
          </li>
          <li>
            <strong>Gentle, clear language.</strong> Mental health conversations don&apos;t
            need to be heavy or clinical. Wellness Minds uses simple words and relatable
            examples to make emotional support feel approachable.
          </li>
          <li>
            <strong>Digital-first support.</strong> Using tools like WhatsApp chatbots and
            guided check-ins, Wellness Minds meets people where they already are, on their
            phones, in small, digestible steps.
          </li>
        </ul>

        <h2 className="about-heading">How Wellness Minds helps</h2>
        <p>
          Instead of overwhelming people with long guides or complex frameworks, Wellness
          Minds breaks support into small, practical steps:
        </p>
        <ul className="about-list">
          <li>
            Short emotional check-ins that help you name whether you&apos;re stressed,
            exhausted, anxious, low or &quot;just not okay&quot;.
          </li>
          <li>
            Connecting feelings with possible causes like workload, burnout, lack of rest,
            difficult relationships or emotional overload.
          </li>
          <li>
            Offering a handful of realistic actions you can take today — a pause, a boundary,
            a conversation, or a moment of care for yourself.
          </li>
        </ul>

        <h2 className="about-heading">What Wellness Minds is not</h2>
        <p>
          Wellness Minds does not replace therapy, psychiatry or emergency mental health
          support. It is not meant for crisis situations. Instead, it sits earlier in the
          journey — helping people notice when something feels off and encouraging them to
          take supportive steps, including seeking professional help when needed.
        </p>

        <p className="section-outro">
          Whether you are quietly struggling yourself or building tools to support others,
          Wellness Minds aims to be a calm, steady companion on the path to better mental
          wellbeing.
        </p>
      </div>
    </section>
  );
};

export default About;
